import React from 'react';
import { Route, Routes, useLocation} from 'react-router-dom';

import PaymentPage from "../payment-page";
import PaymentResultPage from "../payment-result-page";
import i18n from "../../translations/i18n";
import {RU_LANG_CODE} from "../../translations/ru";
import {KZ_LANG_CODE} from "../../translations/kz";
const App = () => {
    const location = useLocation()
    i18n.changeLanguage(RU_LANG_CODE);
    if (location.pathname.indexOf("kz")>0){
        i18n.changeLanguage(KZ_LANG_CODE);
    }

    return (
        <Routes>
            <Route path="/" element={<PaymentPage/>} exact={true}/>
            <Route path="/ru" element={<PaymentPage/>} exact={true}/>
            <Route path="/kz" element={<PaymentPage/>} exact={true}/>
            <Route path="/success" element={<PaymentResultPage success={true}/>} exact={true}/>
            <Route path="/error" element={<PaymentResultPage success={false}/>} exact={true}/>
            <Route path="/ru/success" element={<PaymentResultPage success={true}/>} exact={true}/>
            <Route path="/kz/success" element={<PaymentResultPage success={true}/>} exact={true}/>
            <Route path="/ru/error" element={<PaymentResultPage success={false}/>} exact={true}/>
            <Route path="/kz/error" element={<PaymentResultPage success={false}/>} exact={true}/>
            <Route path="/:data" element={<PaymentPage  />} exact={true}/>
            <Route path="/ru/:data" element={<PaymentPage/>} exact={true}/>
            <Route path="/kz/:data" element={<PaymentPage/>} exact={true}/>

        </Routes>
    )
}
export default App;